import { setYear, startOfYear, getHours, getMinutes, setHours, setMinutes } from 'date-fns';

export default function dateToTime(date) {
  const hours = getHours(date);
  const minutes = getMinutes(date);
  return setMinutes(setHours(setYear(startOfYear(new Date()), 1900), hours), minutes);
};
